<form [formGroup]="addRuleForm" (ngSubmit)="addRule()">
  <div class="row">
    <div class="form-group col-md-3">
      <label>Name</label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addRuleForm, 'name')" formControlName="name" placeholder="Name" required>
    </div>
    <div class="form-group col-md-7">
      <label>Query <small>({{addRuleForm.value.value.length}}/512 chars)</small></label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addRuleForm, 'value')" formControlName="value" placeholder="Query" maxlength="512" required>
    </div>
    <div class="form-group col-md-2">
      <label class="d-none d-md-block">&nbsp;</label>
      <button class="btn btn-success" type="button" (click)="validateRule()" [disabled]="!addRuleForm.valid">
        <i class="fa fa-check-circle"></i> Validate
      </button>
      <label class="d-none d-md-inline-block">&nbsp;</label>
      <button class="btn btn-primary ms-1" type="submit" [disabled]="!addRuleForm.valid">
        <i class="fa fa-plus-circle"></i> Add query
      </button>
    </div>
  </div>
</form>